import BlockedSendersOptionState from '../store/schema/BlockedSendersOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import { action, select } from 'satcheljs/lib/legacy';
import {
    getMailboxJunkEmailConfiguration,
    saveMailboxJunkEmailConfiguration,
} from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';

export interface SaveBlockedSendersOptionState {
    optionState: BlockedSendersOptionState;
    mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions;
}

export default select<SaveBlockedSendersOptionState>({
    mailboxJunkEmailConfiguration: () => getMailboxJunkEmailConfiguration(),
    optionState: () => store,
})(
    action('saveBlockedSendersOption')(async function saveBlockedSendersOption(
        state?: SaveBlockedSendersOptionState
    ): Promise<void> {
        const { mailboxJunkEmailConfiguration, optionState } = state!;
        const blockedSenders = getFallbackValueIfNull(
            optionState.blockedSenders,
            mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(item =>
                isEmailAddress(item)
            )
        );
        const blockedDomains = mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(
            item => !isEmailAddress(item)
        );
        const blockedSenderAndDomains = blockedSenders.slice(0).concat(blockedDomains);
        mailboxJunkEmailConfiguration.BlockedSendersAndDomains = blockedSenderAndDomains;
        await saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration);
    })
);
